<template>
  <div class="trainer-hints trahints">
    <UnSwitcherNew
      :hasText="true"
      :asMenu="false"
      swKey="sw_study_range_center"
      style="--gwbtn-flex: 1; margin: 0 0 0.5rem 0"
    />
    <StudyRangesCenter
      v-bind="ccProps"
      :namespace="''"
      :canAISolve="false"
      :grouping="grouping"
      :hasExpandOverlay="!mobile"
      :hasHideBtn="true"
      :isPreflop="isPreflop"
      :learningMode="!infoVisible"
      :showBetsIn="showBetsIn"
      :showFlopContent="showFlopContent"
      :simpleView="true"
      :skeletonOnly="!infoVisible || !apiData"
      :useHex="useHex"
      style="
        --tracactr-item-active: var(--clr-white-0);
        --tracactr-item-inactive: var(--clr-black-10);
      "
      @toggle="toggle"
      @table:click="handleTableClick"
      @eqchart:click="handleEqChartClick"
      @eqchart:mousedown="computeSolData"
    />
  </div>
</template>

<script>
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import {
  getFilterCategories,
  getSolPlayer,
  getSolution,
  getAvailableActionsFromApiSolutions,
  getSolutionPick,
  updateTableGroups,
} from '@/helpers/solution'

import StudyRangesCenter from '@/components/Study/StudyRangesCenter'

import float_mix from '@/mixins/float_mix'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'TrainerHints',
  components: {
    StudyRangesCenter,
    UnSwitcherNew,
  },
  mixins: [float_mix, links_mix],
  props: {
    namespace: { String, required: true },
    skeleton: Boolean,
    spot: Object,
    pref: Object,
    infoVisible: Boolean,
    combos: { default: () => [] },
  },
  data() {
    this.heroIndex = 0
    return {
      showProp: 'range',
      strategyVisible: false,
      iconTooltips: [this.$t('tooltips.hide'), this.$t('tooltips.show')],
      commonCheckboxProps: {
        icons: ['mdi-eye-off', 'mdi-eye'],
        style: `--clr-disabled:var(--clr-grey-2);--clr-enabled:var(--clr-white-0);--icon-size: 1.25rem;--label-size:0.875rem; --clr-label:var(--clr-grey-2) `,
        class: 'label-left mr-auto ',
      },
    }
  },
  created() {
    this.showProp = localStorage.getItem('tra_range_tab') || 'range'
  },

  methods: {
    computeSolData() {
      const apiData = this.spot.api_practice
      this.$store.dispatch('sol_data_setSolProps', { apiData })
    },
    handleTableClick() {
      this.$store.commit('sol_filters_set', { key: 'actions', value: [] })
      this.$store.commit('sol_filters_set', { key: 'categories', value: [] })
      this.$store.dispatch(
        'router_set_dialogs',
        `study-compare-range-dialog_namespace-${this.namespace}`,
      )
    },
    handleEqChartClick() {
      this.$store.dispatch('router_set_dialogs', `chart-eq-dialog_namespace-${this.namespace}`)
    },
    setShowProp(str) {
      this.showProp = str
      localStorage.setItem('tra_range_tab', str)
    },
    showRanges() {
      const res = {
        ...this.pref,
        fh_trainer_hero_range: 'on',
        fh_trainer_opponent_range: 'on',
      }
      this.updateQuery(res)
    },
    showStrategy() {
      const res = {
        ...this.pref,
        fh_trainer_hero_strategy: 'on',
      }
      this.updateQuery(res)
    },
    toggle(key) {
      const dict = {
        hasEqChart: 'fh_trainer_equity_chart',
        hasHorizontalChart: 'fh_trainer_total_frequency',
        hasHandStrength: 'fh_trainer_hand_strength',
        hasRangesComparison: 'fh_trainer_ranges_comparison',
        hasRangeCategoriesHands: 'fh_trainer_category_hands',
        hasRangeCategoriesDraws: 'fh_trainer_category_draws',
        hasSimpleRangeHeroStrategy: 'fh_trainer_hero_strategy',
        hasSimpleRangeHero: 'fh_trainer_hero_range',
        hasSimpleRangeOpponent: 'fh_trainer_opponent_range',
      }
      // console.log(this.pref[dict[key]])
      const res = {
        ...this.pref,
        [dict[key]]: this.pref[dict[key]] ? '' : 'on',
      }
      // console.log(res)
      this.updateQuery(res)
    },
    updateQuery(query) {
      this.$store.dispatch(`${this.namespace}/router_update_query`, {
        query,
        push: false,
      })

      const namespaces = ['tra/alpha', 'tra/beta', 'tra/gamma', 'tra/delta']
      namespaces.forEach(nn => {
        if (nn !== this.namespace) {
          this.$store.dispatch(`${nn}/router_update_query`, {
            query,
            push: false,
            replace: false,
            saveLocally: false,
          })
        }
      })
    },
  },
  computed: {
    isPreflop() {
      return this.spot?.street === 'preflop'
    },
    showFlopContent() {
      return !!this.spot?.custom_solution_id || !this.isPreflop
    },
    grouping() {
      return this.$store.getters.sw_actions_grouping
    },
    useHex() {
      return this.$store.getters.sw_actions_grouping === 'swv_grouping_none'
    },
    ccProps() {
      const { pref } = this
      const stratab = this.$store.getters.sw_study_range_center === 'strategy'
      const view = {
        hasHorizontalChartItem: stratab,
        hasHorizontalChart: stratab && !!pref.fh_trainer_total_frequency,
        hasRangeCategoriesItem: stratab && this.showFlopContent,
        hasRangeCategories:
          stratab &&
          this.showFlopContent &&
          (!!pref.fh_trainer_category_hands || !!pref.fh_trainer_category_draws),
        hasRangeCategoriesHands: !!pref.fh_trainer_category_hands,
        hasRangeCategoriesDraws: !!pref.fh_trainer_category_draws,
        hasRangesComparisonItem: !stratab && this.showFlopContent,
        hasRangesComparison:
          !stratab && this.showFlopContent && !!pref.fh_trainer_ranges_comparison,
        hasRangesComparisonTitlePlayers: true,
        hasEqChartItem: !stratab && this.showFlopContent,
        hasEqChart: !stratab && this.showFlopContent && !!pref.fh_trainer_equity_chart,
        handsPinnedHero: this.handInfo ? [this.handInfo.hand] : null,
        hasHandStrengthItem: stratab && this.showFlopContent,
        hasHandStrength: stratab && this.showFlopContent && !!pref.fh_trainer_hand_strength,

        hasSimpleRange: stratab
          ? !!pref.fh_trainer_hero_strategy
          : !!pref.fh_trainer_hero_range || !!pref.fh_trainer_opponent_range,
        hasSimpleRangeHeroStrategy: stratab && !!pref.fh_trainer_hero_strategy,
        hasSimpleRangeHero: !stratab && !!pref.fh_trainer_hero_range,
        hasSimpleRangeOpponent: !stratab && !!pref.fh_trainer_opponent_range,
        viewStrategy: stratab,
        rangeKey: this.$store.getters.sol_view_viewProps.rangeKey,

        hasSimpleRangeItem: true,
        hasHorizontalChartTitle: true,
        hasRangesComparisonTitle: true,
        hasEqChartTitle: true,
        hasGroupingSwitcher: true,
        hasRangeHeightSwitcher: true,
      }

      const hasPlayers = view.hasSimpleRange || view.hasEqChart || view.hasRangesComparison
      const data = {
        solution_picked: view.hasHorizontalChart ? this.solution_picked : [],
        tableGroups: view.hasSimpleRange ? this.tableGroups : [],

        hasHands: !this.isPreflop,
        hasDraws: !this.isPreflop,
        hasEqBuckets: !this.isPreflop && !stratab,
        hasEqBucketsAdvanced: !this.isPreflop && !stratab,

        hasHandsTitle: !this.isPreflop,
        hasDrawsTitle: !this.isPreflop,
        hasEqBucketsTitle: false,
        hasEqBucketsAdvancedTitle: false,

        catDraws: this.catDraws,
        catHands: this.catHands,
        catEqBuckets: this.catEqBuckets,
        catEqBucketsAdvanced: this.catEqBucketsAdvanced,

        handInfo: this.handInfo,
        // handsPinnedHero: view.hasHandStrength ? [this.handInfo?.hand || ''] : null,
        handsPinnedHero: [this.handInfo?.hand || ''],
        hero: hasPlayers ? this.hero : null,
        opponent: hasPlayers ? this.opponent : null,
        heroLeft: hasPlayers ? this.heroLeft : false,
        invalidSolution: view.hasHandStrength ? this.invalidSolution : false,

        playerLeft: hasPlayers ? this.hero : null,
        playerRight: hasPlayers ? this.opponent : null,
        playerLeftKey: '0',
        playerRightKey: '1',
      }
      const res = {
        ...view,
        ...data,
      }

      // console.log(res, pref)
      return res
    },
    apiData() {
      return this.spot?.api_practice
    },
    invalidSolution() {
      return !this.apiData?.has_valid_solution
    },
    solution() {
      if (!this.apiData) return []
      const available_actions = getAvailableActionsFromApiSolutions({ solData: this.apiData })
      const res = getSolution({
        solution: this.apiData.solutions || [],
        available_actions,
      })
      return res
    },
    solution_picked() {
      return getSolutionPick({ solution: this.solution })
    },
    tableGroups() {
      const tableGroups = this.$store.getters.ske_tableGroups()
      if (!this.apiData) return tableGroups
      const res = updateTableGroups({
        tableGroups,
        combos: null,
        players: [this.hero, this.opponent],
        solution: this.solution_picked,
      })
      return res
    },
    catDraws() {
      let res = getFilterCategories({
        categoryId: 'draw_categories',
        categoriesRange: null,
        solution: this.solution,
        players: [this.hero, this.opponent],
      })
      res = res.filter(i => i.players[this.heroIndex].total_occurrence)
      return res
    },
    catHands() {
      let res = getFilterCategories({
        categoryId: 'hand_categories',
        categoriesRange: null,
        solution: this.solution,
        players: [this.hero, this.opponent],
      })
      res = res.filter(i => i.players[this.heroIndex].total_occurrence)
      return res
    },
    catEqBuckets() {
      let res = getFilterCategories({
        categoryId: 'equity_buckets',
        categoriesRange: null,
        solution: this.solution,
        players: [this.hero, this.opponent],
      })
      res = res.filter(i => i.players[this.heroIndex].total_occurrence)
      return res
    },
    catEqBucketsAdvanced() {
      let res = getFilterCategories({
        categoryId: 'equity_buckets_advanced',
        categoriesRange: null,
        solution: this.solution,
        players: [this.hero, this.opponent],
      })
      res = res.filter(i => i.players[this.heroIndex].total_occurrence)
      return res
    },
    handInfo() {
      return this.apiData?.hand_info
    },
    practicePlayersInfo() {
      return this.apiData?.players_info || []
    },
    hero() {
      return getSolPlayer({ player: this.practicePlayersInfo.find(i => i.player?.is_hero) })
    },
    opponent() {
      return getSolPlayer({ player: this.practicePlayersInfo.find(i => !i.player?.is_hero) })
    },
    heroLeft() {
      return !this.opponent?.position || this.hero.relative_postflop_position === 'OOP'
    },
    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
  },
}
</script>
<style lang="scss" scoped>
.trahints {
  // display: flex;
  // flex-direction: column;
  flex: 1;
  min-height: 0;
  // gap: 0.5rem;
}
</style>
